export default {
    links:[
        {
            path: "/app/credit_list/credit_info",
            label: "Credit Requirement"
        },
        {
            path: "/app/credit_list/credit_info/doc_upload",
            label: "Docs Upload"
        }
    ]
}